import { render, staticRenderFns } from "./FeatureApp.vue?vue&type=template&id=359e8a3a&"
import script from "./FeatureApp.vue?vue&type=script&lang=js&"
export * from "./FeatureApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports